/**
 * Clamps a value between two inclusive limits
 *
 * @param value
 * @param min lower limit
 * @param max upper limit
 */
export function clamp(value: number, min: number, max: number): number {
    const clampedValue = Math.min(max, Math.max(min, value));

    return clampedValue;
}
